import React__default from 'react';
import { isFunction, __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import { useMenu, MenuProvider } from './use-menu.esm.js';
export { default as MenuButton } from './MenuButton/index.esm.js';
export { default as MenuDivider } from './MenuDivider/index.esm.js';
export { default as MenuGroup } from './MenuGroup/index.esm.js';
export { default as MenuItem } from './MenuItem/index.esm.js';
export { default as MenuItemOption } from './MenuItemOption/index.esm.js';
export { default as MenuList } from './MenuList/index.esm.js';
export { default as MenuOptionGroup } from './MenuOptionGroup/index.esm.js';

/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */

var Menu = function Menu(props) {
  var context = useMenu(props);
  var open = context.open,
      onClose = context.onClose;
  var children = props.children;
  return React__default.createElement(MenuProvider, {
    value: context
  }, isFunction(children) ? children({
    open: open,
    onClose: onClose
  }) : children);
};

if (__DEV__) {
  Menu.displayName = 'Menu';
}

export default Menu;
//# sourceMappingURL=index.esm.js.map
